module.exports = __webpack_public_path__ + "operace-ocnich-vicek-dolni_3_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/operace-ocnich-vicek-dolni_3_after_tn.jpg
// module id = 1617
// module chunks = 0